import { render, staticRenderFns } from "./conclusion.vue?vue&type=template&id=35616216&scoped=true"
import script from "./conclusion.vue?vue&type=script&lang=js"
export * from "./conclusion.vue?vue&type=script&lang=js"
import style0 from "./conclusion.vue?vue&type=style&index=0&id=35616216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35616216",
  null
  
)

export default component.exports